import { render, staticRenderFns } from "./DocumentTemplateDetailInformation.vue?vue&type=template&id=d2ae260e&scoped=true&"
import script from "./DocumentTemplateDetailInformation.vue?vue&type=script&lang=ts&"
export * from "./DocumentTemplateDetailInformation.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTemplateDetailInformation.vue?vue&type=style&index=0&id=d2ae260e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ae260e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardText,VCheckbox,VChip,VForm,VRow,VSelect,VSimpleTable,VSpacer,VTextField,VTextarea})
